import { render, staticRenderFns } from "./PsConfigurationPhases.vue?vue&type=template&id=d5850950&scoped=true&"
import script from "./PsConfigurationPhases.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationPhases.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationPhases.vue?vue&type=style&index=0&id=d5850950&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5850950",
  null
  
)

export default component.exports